/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TunnelSectionDto } from '../../models/tunnel-section-dto';

export interface UpdateTunnelSection$Params {
  id: string;
      body: TunnelSectionDto
}

export function updateTunnelSection(http: HttpClient, rootUrl: string, params: UpdateTunnelSection$Params, context?: HttpContext): Observable<StrictHttpResponse<TunnelSectionDto>> {
  const rb = new RequestBuilder(rootUrl, updateTunnelSection.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TunnelSectionDto>;
    })
  );
}

updateTunnelSection.PATH = '/v1/tunnelsections/{id}';
